import { shape, string, number } from 'prop-types';
import { createTheme } from '@material-ui/core/styles';
import ChannelAnalytics from '../../components/DashboardTab/ChannelsAnalytics';
import DaypartAnalytics from '../../components/DashboardTab/DaypartAnalytics';
import GeoFencing from '../../components/DashboardTab/GeoFencing/GeoFencingReport';
import CreativeAnalytics from '../../components/DashboardTab/CreativeAnalytics';
import PlacementAnalytics from "../../components/DashboardTab/PlacementAnalytics";
import WebAnalytics from '../../components/DashboardTab/WebAnalytics';
import PagePathAnalytics from '../../components/DashboardTab/PagePathAnalytics';
import DeviceCategory  from '../../components/DashboardTab/DeviceCategory';
import { ADTYPE_CHART_ID, ADVISIT_BY_DAY_OF_WEEK_CHART_ID, ADVISIT_CHART_ID, AD_PERFORMANCE_CHART_ID, CHANNELS_TAB, CREATIVE_TAB, DAYPART_COMPILATION_CHART_ID, DAYPART_TAB, DEVICE_CATEGORY_CHART_ID, DEVICE_CATEGORY_TAB, GA_CHART_ID, GEO_CHART_ID, KEYWORD_CHART_ID, LOCATION_TAB, PAGE_PATH_CHART_ID, PAGE_PATH_TAB, PLACEMENT_TAB, REPORTS_TAB, STATION_CHART_ID, TRAFFIC_CHANNEL_CHART_ID, WEB_TAB } from '../../helpers/constant';

export const reportInfoShape = shape({
  advertiserName: string,
  campaignName: string,
  email: string,
  logo: shape({
    logoTDOid: string,
    url: string,
    loadedTimeTracking: number
  }),
  name: string,
  template: string,
});

export const reportItemType = {
  all: 'chartsAndTablesSelect',
  chart: 'chartsSelect',
  table: 'tablesSelect',
  none: 'emptyReportSelect',
  custom: 'customReportSelect',
  modified: 'modified',
  simple: 'simple',
  comprehensive: 'comprehensiveReportSelect'
};

export const iHMTemplateChoice = {
  label: 'iHeart Standard Report',
  value: reportItemType.custom
};

export const modifiedTemplate = {
  label: 'Custom',
  value: reportItemType.modified
}

export const comprehensiveTemplateChoice = {
  label: 'Comprehensive Report',
  value: reportItemType.comprehensive
}

export const templateChoices = [
  {
    label: 'Charts & Tables',
    value: reportItemType.all
  },
  {
    label: 'Charts only',
    value: reportItemType.chart
  },
  {
    label: 'Tables only',
    value: reportItemType.table
  },
  {
    label: 'Empty Report',
    value: reportItemType.none
  }
];

export const SimpleTemplateChoise =  {
  label: 'Simple Report',
  value: reportItemType.simple
};

export const defaultReportInfo = {
  name: '',
  email: '',
  phoneNumber: '',
  template: 'Empty Report'
};

export const deleteButtonTheme = createTheme({
  overrides: {
    MuiSvgIcon: {
      root: {
        '&:first-child': {
          fontSize: '18px'
        }
      }
    },
    MuiIconButton: {
      root: {
        padding: '4px'
      }
    }
  }
});

export const allDataIncludeText = "All data included";

export const reportInfoSectionType = {
  edit: 'edit',
  view: 'view',
};

export const logoType = {
  primary: 'primary',
  advertiser: 'advertiser',
};

export const stepShape = {
  label: string,
  key: string
};

export const phoneInputShape = {
  width: string,
  height: string,
  border: string,
  borderRadius: string
};

export const reportDateRangeShape = shape({
  start: string,
  end: string,
});

export const mapComponent = {
  "location": {
    component: GeoFencing,
    pageTitle: 'Location',
    pageDescription: 'Understand how different markets performed and optimize using visits per ad or efficiency.',
    filterPropKeys: [
      "advertiser",
      "campaign",
      "chartData",
      "notifications",
      "dateRange",
      "chartKey",
      "haveData"
    ],
  },
  "creative": {
    component: CreativeAnalytics,
    pageTitle: 'Creative Analytics',
    pageDescription: 'Evaluate and optimize based on the best performing creative messages using visits per ad or efficiency.',
    filterPropKeys: [
      "advertiser",
      "campaign",
      "chartData",
      "notifications",
      "dateRange",
      "isConnectGA",
      "range",
      "haveData",
      "reportBuilder"
    ]
  },
  "trafficChannels": {
    component: ChannelAnalytics,
    pageTitle: 'Traffic Channels Analytics',
    pageDescription: "Evaluate performance based on how web activity is classified on the advertiser's website.",
    filterPropKeys: [
      "advertiser",
      "campaign",
      "chartData",
      "notifications",
      "dateRange",
      "reportBuilder"
    ]
  },
  "daypart": {
    component: DaypartAnalytics,
    pageTitle: 'Daypart Analytics',
    pageDescription: 'Analyze the impact of a campaign at the daypart or other time-based metric. Optimize your current or future campaign by viewing average visits per ad or efficiency.',
    filterPropKeys: [
      "advertiser",
      "campaign",
      "dateRange",
      "chartData",
      "data",
      "reportBuilder"
    ]
  },
  "webAnalytics": {
    component: WebAnalytics,
    pageTitle: 'Web analytics',
    pageDescription: 'View top-level web site visitation habits during, before or after a campaign. Compare visits side by side to see the effects of the campaign.',
    filterPropKeys: [
      "advertiser",
      "campaign",
      "chartData",
      "dateRange",
      "isConnectGA",
      "haveData",
      "setChartSelector",
      "reportBuilder"
    ]
  },
  "placement": {
    component: PlacementAnalytics,
    pageTitle: 'Placement Analytics',
    pageDescription: 'Understand the best stations or the relationship between recorded ads and live mentions. Optimize using average visits per ad.Analyze the impact of a campaign at the daypart or other time-based metric. Optimize your current or future campaign by viewing average visits per ad or efficiency.Understand the best stations or the relationship between recorded ads and live mentions. Optimize using average visits per ad.',
    filterPropKeys: [
      "chartData",
      "advertiser",
      "dateRange",
      "isConnectGA",
      "range",
      "haveData",
      "campaign",
      "setChartSelector",
      "notifications",
      "reportBuilder"
    ]
  },
  "deviceCategory": {
    component: DeviceCategory,
    pageTitle: 'Device Category Analytics',
    pageDescription: '',
    filterPropKeys: [
      "advertiser",
      "campaign",
      "chartData",
      "notifications",
      "dateRange",
    ]
  },
  "pagePath": {
    component: PagePathAnalytics,
    pageTitle: 'Page Path Analytics',
    pageDescription: '',
    filterPropKeys: [
      "advertiser",
      "campaign",
      "chartData",
      "notifications",
      "dateRange",
    ]
  }
}

export const contactInfoShape = shape({
  name: string,
  email: string,
  phoneNumber: string,
  dialCode: string,
});

export const reportPropertiesShape = shape({
  reportName: string,
  reportNotes: string,
  emailError: string,
  phoneNumberError: string,
  reportDateRange: {
    start: string,
    end: string,
  }
});

export const daypartChartId = 'daypartAnalyticsChart';
export const keywordReportTableId = 'keywordReportTable';

export const pagePathId = 'pagePath';
export const pagePathChartId = 'pagePathChart';
export const pagePathTableId = 'pagePathTable';

export const deviceCategoryId = 'deviceCategory';
export const deviceCategoryChartId = 'deviceCategoryChart';
export const deviceCategoryTableId = 'deviceCategoryTable';

export const webAnalyticsId = 'webAnalytics';
export const daypartId = 'daypart';
export const placementId = 'placement';
export const creativeId = 'creative';
export const locationId = 'location';
export const trafficChannelsId = 'trafficChannels';
export const reportsId = 'reportsId';

export const LIST_CAMPAIGN_TOPICS = [
  webAnalyticsId,
  daypartId,
  placementId,
  creativeId,
  locationId,
  trafficChannelsId,
  deviceCategoryId,
  pagePathId
];

export const CHARTS_IN_TAB_IDS = {
  //NOTE: GA_CHART must load first in order to get summary data for now, so it's excluded in webanalytics
  [webAnalyticsId]: [GA_CHART_ID, ADVISIT_BY_DAY_OF_WEEK_CHART_ID, AD_PERFORMANCE_CHART_ID],
  [daypartId]: [DAYPART_COMPILATION_CHART_ID],
  [placementId]: [ADTYPE_CHART_ID, STATION_CHART_ID],
  [creativeId]: [ADVISIT_CHART_ID],
  [locationId]: [GEO_CHART_ID],
  [trafficChannelsId]: [TRAFFIC_CHANNEL_CHART_ID, KEYWORD_CHART_ID],
  [deviceCategoryId]: [DEVICE_CATEGORY_CHART_ID],
  [pagePathId]: [PAGE_PATH_CHART_ID],
};

export const HASH_MAP_TAB_IDS = {
  [WEB_TAB]: webAnalyticsId,
  [DAYPART_TAB]: daypartId,
  [PLACEMENT_TAB]: placementId,
  [CREATIVE_TAB]: creativeId,
  [LOCATION_TAB]: locationId,
  [CHANNELS_TAB]: trafficChannelsId,
  [DEVICE_CATEGORY_TAB]: deviceCategoryId,
  [PAGE_PATH_TAB]: pagePathId,
  [REPORTS_TAB]: reportsId
}

export const ga4Message =
  'You may notice some changes in your Veritone Attribute report! Since Attribute most frequently relies on Google Analytics, we made some edits to remain compatible with the new, required version called GA4. Metrics no longer available with GA4 have been replaced with enhanced visualizations and data tables to provide you with more strategic insights and analytics.';

export const disabledText = 'Unavailable in GA4';
